import { el } from "../lib/dom";

export function mountLocation(location: string): HTMLElement {
  return el("span", { class: "location", "aria-label": `Location: ${location}` }, [
    el("span", { class: "location__pin", "aria-hidden": "true" }, ["📍"]),
    " ",
    location,
  ]);
}
